import { Container, styled } from '@mui/material';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';

export const StyledAppDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  width: '100%',
}));

export function AppDataGrid({ initialState, pageSizeOptions, ...props }: DataGridProps) {
  return (
    <StyledAppDataGrid
      initialState={
        initialState || {
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }
      }
      pageSizeOptions={pageSizeOptions || [10, 25, 50, 100]}
      {...props}
    />
  );
}

export const FlexDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // justifyContent: 'space-between',
  flex: 1,
  gap: '1rem',
  flexWrap: 'wrap',

  '& > *': {
    flexBasis: 'calc(25% - 0.75rem)',
    minWidth: '240px',
  },

  [theme.breakpoints.down('lg')]: {
    '& > *': {
      flexBasis: 'calc(50% - 0.5rem)',
    },
  },

  [theme.breakpoints.down('sm')]: {
    '& > *': {
      flexBasis: '100%',
    },
  },
}));

export const FlexDivCol = styled(FlexDiv)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const AppContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  gap: '16px',
  marginTop: 0,
  marginBottom: 40,
  maxWidth: '100% !important',
  paddingLeft: 0,
  paddingRight: 0,
}));

// Recolored to the CloudCost.dc.html design accents. Index order preserved so
// existing chart logic (which references CHART_COLORS[0..5]) keeps its meaning.
export const CHART_COLORS = [
  '#1C71E3', // [0] blue — efficient / current spend / VMs
  '#F28E2C', // [1] orange — forecast / saving potential / storage
  '#E23D3D', // [2] red — rejected
  '#7A4FD6', // [3] purple — AI / networking
  '#16A55C', // [4] green
  '#B26A12', // [5] amber
  '#53A6F0', // [6] light blue
  '#ff9da7',
  '#9c755f',
  '#bab0ab',
  '#b07289',
  '#6a93c1',
  '#548fa7',
  '#e07a5f',
  '#d35400',
  '#f38630',
  '#c7293a',
  '#bc1a45',
  '#6ab04c',
  '#81b622',
  '#a7d1ab',
  '#e3cc98',
  '#c0957f',
  '#d4a373',
  '#bda6ba',
  '#8e6c89',
  '#c28fa1',
  '#d07f95',
  '#a384ab',
  '#b8bab0',
  '#968e7f',
];

export const ATTESTATION_COLORS = {
  // Actual costs (strong colors) — aligned to design donut palette
  pending: '#F28E2C',
  confirmed: '#16A55C',
  rejected: '#E23D3D',

  // Forecast costs (lighter colors)
  pendingForecast: '#FBD9A8',
  confirmedForecast: '#A7DCC0',
  rejectedForecast: '#F5B4B4',
};

export const BUDGET_COLORS = {
  budget: '#1C71E3',
  total: '#16233A',
  attested_cost: '#C6CFDC',
};
